import { getAll } from '../_api'

const getPages = ({ commit }) => {
    return new Promise((resolve, reject) => {
        getAll()
        .then(result => {
            commit('setPages', { pages: result })
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

/* Necessary to return a promise and catch the response */
const setCurrentPage = ({ commit }, { page }) => {
    commit('setCurrentPage', { page: page })
}

export default {
    setCurrentPage,
    getPages
}
